module.exports = __webpack_public_path__ + "img/imgCamera.657be056.png";